module.exports = __webpack_public_path__ + "static/media/designPatent_30-0995299.2b43ba47.png";